/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./table-modular.vue?vue&type=template&id=aff1860a&"
import script from "./table-modular.vue?vue&type=script&lang=ts&"
export * from "./table-modular.vue?vue&type=script&lang=ts&"
import style0 from "./table-modular.vue?vue&type=style&index=0&id=aff1860a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports